module.exports = __webpack_public_path__ + "static/campaign-builder-1d7a3a048e3ee3414e224c0cccd82c9b.svg";